import { SidebarElement } from 'sidebarjs';

(function ($) {
	$(document).ready(function () {
		const menuResponsive = new SidebarElement({
			position: 'left'
		});
		const menuResponsiveMarkup = $('.nav-responsive');
		const menuResponsiveButton = $('.nav-responsive__button');
		const menuResponsiveItemsWithChildren = $('.nav-responsive .menu-item-has-children');

		const menuResponsiveButtonSubmenuMarkup = `
			<button class="sub-menu__button open">
			<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 384 512"><!--! Font Awesome Pro 6.4.0 by @fontawesome - https://fontawesome.com License - https://fontawesome.com/license (Commercial License) Copyright 2023 Fonticons, Inc. --><path d="M376.6 84.5c11.3-13.6 9.5-33.8-4.1-45.1s-33.8-9.5-45.1 4.1L192 206 56.6 43.5C45.3 29.9 25.1 28.1 11.5 39.4S-3.9 70.9 7.4 84.5L150.3 256 7.4 427.5c-11.3 13.6-9.5 33.8 4.1 45.1s33.8 9.5 45.1-4.1L192 306 327.4 468.5c11.3 13.6 31.5 15.4 45.1 4.1s15.4-31.5 4.1-45.1L233.7 256 376.6 84.5z"/></svg>
			</button>
		`;

		menuResponsiveMarkup.css('display', 'unset');

		menuResponsiveButton.click(function () {
			menuResponsive.toggle();
		});

		menuResponsiveItemsWithChildren.append(menuResponsiveButtonSubmenuMarkup);

		const menuResponsiveButtonSubmenu = $('.nav-responsive .sub-menu__button');

		menuResponsiveButtonSubmenu.click(function () {
			if ($(this).hasClass('open')) {
				$(this).siblings('.sub-menu').addClass('opened');
			}

			if ($(this).hasClass('close')) {
				$(this).siblings('.sub-menu').removeClass('opened');
			}

			$(this).toggleClass('open');
			$(this).toggleClass('close');
		});
	});
})(jQuery);
